var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "error-a",
    d: "M12.4470257,2 C13.4301156,2 14.3463146,2.48123456 14.9074794,3.28406598 L15.0148931,3.44887293 L23.4930162,17.6026836 C24.0260538,18.5257831 24.0292363,19.662404 23.5013765,20.5884739 C23.0065078,21.4566645 22.1145858,22.0175494 21.1177131,22.0939716 L20.9170257,22.102744 L3.96603518,22.102744 C2.9001532,22.0909683 1.92053484,21.5145439 1.39267496,20.5884739 C0.900005737,19.724142 0.869933469,18.6763967 1.30809714,17.7787962 L1.40915829,17.5888729 L9.87915829,3.44887293 C10.4258742,2.54753799 11.3983964,2 12.4470257,2 Z M12.4470257,4 C12.1418461,4 11.8560046,4.13912417 11.6677151,4.37333738 L11.5932202,4.47940787 L3.13301624,18.6028044 C2.95533705,18.9105042 2.95427621,19.2893779 3.1302295,19.5980678 C3.28418863,19.8681716 3.55344029,20.0490429 3.84900402,20.0926564 L3.97702571,20.1028044 L20.9060352,20.1028044 C21.2613292,20.0988993 21.5878686,19.9067578 21.7638219,19.5980678 C21.917781,19.3279641 21.9362137,19.004126 21.824827,18.7305041 L21.7691583,18.6166151 L13.3020257,4.481372 C13.1207429,4.18251266 12.7965688,4 12.4470257,4 Z M11.7399189,16.3956372 C12.1304432,16.0051129 12.7636082,16.0051129 13.1541325,16.3956372 C13.5446568,16.7861615 13.5446568,17.4193265 13.1541325,17.8098508 C12.7636082,18.2003751 12.1304432,18.2003751 11.7399189,17.8098508 C11.3493946,17.4193265 11.3493946,16.7861615 11.7399189,16.3956372 Z M12.4470257,8.102744 C12.9598615,8.102744 13.3825329,8.48878419 13.440298,8.98612288 L13.4470257,9.102744 L13.4470257,13.102744 C13.4470257,13.6550288 12.9993105,14.102744 12.4470257,14.102744 C11.9341899,14.102744 11.5115185,13.7167038 11.4537534,13.2193651 L11.4470257,13.102744 L11.4470257,9.102744 C11.4470257,8.55045925 11.894741,8.102744 12.4470257,8.102744 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "error-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#error-a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentcolor",
    fillRule: "nonzero",
    xlinkHref: "#error-a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentcolor",
    mask: "url(#error-b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.b0bfb02ac3ccda4259b7e9a8952aa91b.svg";
export { ForwardRef as ReactComponent };